import { Link } from "react-router-dom";
import { Drama, Mail } from "lucide-react";

const columns = [
  {
    title: "Explore",
    links: [
      { to: "/", label: "Home" },
      { to: "/shows", label: "Browse Shows" },
      { to: "/casts", label: "Casts" },
      { to: "/watchlist", label: "Watchlist" },
      { to: "/news", label: "News" },
    ],
  },
  {
    title: "Discover",
    links: [
      { to: "/quiz", label: "Which role are you?" },
      { to: "/find-a-show", label: "Which show should I see?" },
      { to: "/trivia", label: "Daily Theatre Trivia" },
    ],
  },
  {
    title: "About",
    links: [
      { to: "/about", label: "About Us" },
      { to: "/theatres", label: "Theatre Map" },
      { to: "/theatre-guide", label: "Theatre A-Z" },
      { to: "/contact", label: "Contact Us" },
      { to: "/privacy", label: "Privacy Policy" },
    ],
  },
];

const linkClass = "text-sm text-amber-100/60 transition-colors hover:text-amber-50";

export function Footer() {
  return (
    <footer className="mt-16 border-t border-amber-900/20 bg-[#0D0A0E]">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-amber-100">
              <Drama className="h-6 w-6 text-[#C89B3C]" aria-hidden="true" />
              <span className="font-serif text-xl font-semibold tracking-tight">My Theatre</span>
            </Link>
            <p className="mt-3 max-w-xs text-sm text-amber-100/50">
              Follow West End shows and performers, and never miss a cast change.
            </p>
            <a href="mailto:hello@mytheatre.uk" className={`mt-4 inline-flex items-center gap-1.5 ${linkClass}`}>
              <Mail className="h-3.5 w-3.5" aria-hidden="true" /> hello@mytheatre.uk
            </a>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h2 className="text-xs font-semibold uppercase tracking-widest text-[#C89B3C]">{col.title}</h2>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className={linkClass}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 border-t border-amber-900/10 pt-6 text-center text-xs text-amber-100/40">
          © {new Date().getFullYear()} My Theatre. Not affiliated with any West End theatre or ticketing provider.
        </div>
      </div>
    </footer>
  );
}